<template>
    <div class="posicao-botao">
        <button @click="toggleAgenda" class="btn-ultima-ligacao">
            📞 Ver último registro
        </button>

        <div v-if="mostrarAgenda" class="agenda-popup">
            <div v-if="ultimaLigacao">
                <div class="info-bloco">
                    <!-- exibe dados normalmente -->
                    <div class="info-item-linha">
                        <span class="info-label">Número:</span>
                        <span @click="call_client(ultimaLigacao.nome)" class="info-valor numero-clicavel"
                            title="Clique para ligar">
                            {{ ultimaLigacao.nome }}
                        </span>
                    </div>

                    <div class="info-item-linha">
                        <span class="info-label">Data/hora:</span>
                        <span class="info-valor">
                            {{ ultimaLigacao.data }} às {{ ultimaLigacao.hora }}
                        </span>
                    </div>

                    <div class="info-item-linha">
                        <span class="info-label">Tipo:</span>
                        <span class="info-valor">
                            {{ ultimaLigacao.tipo }}
                            <span v-if="ultimaLigacao.tipo === 'Recebida' && ultimaLigacao.fila"> ({{ ultimaLigacao.fila
                                }})</span>
                        </span>
                    </div>
                </div>
            </div>

            <div v-else>
                Nenhum registro encontrado.
            </div>
        </div>
    </div>
</template>

<script>
const connection = io.connect(`${location.protocol}//${location.hostname}:3006/`);
export default {
    data() {
        return {
            mostrarAgenda: false,
            ultimaLigacao: null
        }
    },
    methods: {
        formatPhoneToCall(phone) {
            let newPhone = phone.replace(/\D/g, "");
            return newPhone.slice(0, 2) == "55" ? '0' + newPhone.slice(2) : newPhone;
        },
        toggleAgenda() {
            this.mostrarAgenda = !this.mostrarAgenda;
            if (this.mostrarAgenda) {
                this.buscarUltimaLigacao();
            }
        },
        async buscarUltimaLigacao() {
            try {
                const response = await fetch('/dialer/lastCalls');
                const data = await response.json();

                if (!data || !data.data_hora) {
                    // Nenhum registro encontrado
                    this.ultimaLigacao = null;
                    return;
                }

                const dataHora = new Date(data.data_hora);

                if (isNaN(dataHora.getTime())) {
                    // Data inválida, considera como nenhum registro
                    this.ultimaLigacao = null;
                    return;
                }

                const dataFormatada = dataHora.toLocaleDateString('pt-BR');
                const horaFormatada = dataHora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

                this.ultimaLigacao = {
                    nome: data.numero || 'Número desconhecido',
                    data: dataFormatada,
                    hora: horaFormatada,
                    tipo: data.tipo || 'Tipo não informado',
                    fila: data.fila || '',
                };
            } catch (error) {
                console.error('Erro ao buscar última ligação:', error);
                this.ultimaLigacao = null;
            }
        },
        call_client(phoneNumber) {
            if (phoneNumber) {
                connection.emit('Originate', {
                    calltype: 'outgoing',
                    extension: user.getExtension(),
                    phone: this.formatPhoneToCall(phoneNumber)
                });
            }
        }
    }
}
</script>

<style scoped>
.numero-clicavel:hover {
    color: #216db2;
}

.posicao-botao {
    position: absolute;
    top: 20px;
    right: 20px;
}

.btn-ultima-ligacao {
    background-color: #5dade2;
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 12px !important;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: background-color 0.3s, transform 0.2s;
}

.btn-ultima-ligacao:hover {
    background-color: #3498db;
    transform: translateY(-2px);
}

.agenda-popup {
    margin-top: 5px;
    background: #ffffff;
    border-radius: 14px;
    padding: 16px;
    width: 320px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    position: absolute;
    right: 0;
    border: 1px solid #e0e0e0;

    /* Animação */
    animation: fadeSlideIn 0.3s ease forwards;
}

.titulo-popup {
    color: #2d89ef;
    font-weight: 700;
    font-size: 15px;
}

.info-bloco {
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* Espaçamento entre as linhas */
    padding: 0;
    margin: 0;
}

.info-item-linha {
    font-size: 14px;
    line-height: 1.4;
    /* Uma linha confortável */
    color: #333;
    display: flex;
    align-items: center;
}

.info-label {
    font-weight: 600;
    margin-right: 4px;
    color: #2d89ef;
}

.info-valor {
    display: inline;
}

.numero-clicavel {
    cursor: pointer;
    text-decoration: underline;
    color: #007bff;
}

@keyframes fadeSlideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>